import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { fetchServiceRequestStatusApiCallFun, formatDate, fetchdata, getstatementcharges, setActivity, getdata, handleDownloadDocument } from '../../Global/Index';
import ClipLoader from 'react-spinners/ClipLoader';
import './Accountstatement.css'
import { ToastContainer, toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import PaymentFailure from '../Payment Failure/PaymentFailure';
import DatePickerComponent from './Datepicker';
import ServiceStatus from '../All Services/ServiceRequestStatus';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import axios from 'axios';
import { useTheme } from '@mui/material/styles';


const apiurl = process.env.REACT_APP_API_URL;


const overridee = {
    display: "block",
    margin: "10% auto",
    marginLeft: '50%'
};


function calculateAccountStatementAmountWithGST(amount) {

    const gstRate = 18;

    // Calculate reverse GST only for account statement charge
    const originalValue = amount / (1 + gstRate / 100);
    const gstAmount = amount - originalValue;

    // Apply ceiling to the original value
    const ceilingValue = Math.ceil(originalValue);
    return ceilingValue;
}


export default function AccountStatement() {
    const [request, setRequest] = useState({});
    const loanSanctionDateString = useSelector((state) => state.Loan_Sansaction_Date);
    const loanSanctionDate = new Date(loanSanctionDateString);
    const location = useLocation();
    const [toggle, setToggle] = useState('1');
    const [status, setStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [paymentData, setPaymentData] = useState(null);
    const [loanData, setLoanData] = useState(null);
    const [opportunityId, setOpportunityId] = useState(null);
    const [soaPaymentDatas, setSoaPaymentDatas] = useState(null);
    const [isPaymentButtonPressed, setIsPaymentButtonPressed] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [csrfToken, setCsrfToken] = useState('');
    const [showAaccountStatementAmount, setShowAaccountStatementAmount] = useState(null);

   
    const theme = useTheme();
    const navigate = useNavigate();

    useEffect(() => {
        const fun = async () => {
            const data = await getdata();
            if (data.response.status == '200') {
                setOpportunityId(data.response.data.OpportunityId);
                setPhoneNumber(data.response.data.MobileNumber);
            }

            setActivity('Account Statement Page');
            axios.get(`${apiurl}/get-csrf-token`, { withCredentials: true })
                .then(response => {
                    setCsrfToken(response.data.csrfToken);
                })
                .catch(error => {
                    console.error('Error fetching CSRF token:', error);
                });
        }

        fun();
    }, [])

    useEffect(() => {
        if (!opportunityId) return;
        const handleResponseStatus = (status, message) => {
            if (status === "500") {
                console.log('Something went wrong. Please try again later!');
            } else if (status === "503") {
                toast.warn(message);
            }
        };

        const fetchLoanData = async () => {
            try {
                const datas = await fetchdata();
                if (datas.response.status === "200" && opportunityId != null) {
                    const loan = datas.response.data.loanList.find(loan => loan.oppertunityId === opportunityId);
                    const is_Statement_Payment_Allowed_In_allowedServiceList = datas.response?.data?.allowedServicesList?.find(item => item.Name === "Generate Statement of Accounts") !== undefined;

                    if (loan) {
                        if ((loan.LoanStatus == 'Partially Disbursed' || loan.LoanStatus == 'Fully Disbursed (Active)') && is_Statement_Payment_Allowed_In_allowedServiceList) {
                            setLoanData(loan);
                            setSoaPaymentDatas({ "ServiceName": "Account Statement", "LoanStatus": loan.LoanStatus, "SOAPaymentAllowed": loan.SOAPaymentAllowed, "allowedServicesList": is_Statement_Payment_Allowed_In_allowedServiceList })
                        } else {
                            navigate('/success/All-Service-Request');
                        }
                    } else {
                        console.log(`Not getting opportunity Id`);
                    }
                } else if (datas.response.status === "419") {
                    window.location.href = '/Session-Expired'
                } else if (datas.response.status === "500") {
                    console.log('Something went wrong. Please try again later!')
                } else if (datas.response.status === '401') {
                    window.location.href = '/'
                }
            } catch (error) {
                console.log(`error in fetchDataAndSetLoanData function is ${error}`);
            }
        };

        const fetchStatementCharges = async () => {
            const resp = await getstatementcharges();
            if (resp.response.status === "200" && resp.response.message === 'Success') {
                setPaymentData(resp.response.data.accountStatementCharge);
                setShowAaccountStatementAmount(calculateAccountStatementAmountWithGST(resp.response.data.accountStatementCharge));
            } else {
                handleResponseStatus(resp.response.status, resp.response.message);
            }
        };

        const res = async () => {
            await fetchLoanData();
            await fetchStatementCharges();
        };

        res();
    }, [opportunityId]);

    const getQueryParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            status: params.get('status'),
            toggle: params.get('toggle'),
            error_message: params.get('failuredetail'),
        };
    };

    useEffect(() => {
        const { status, toggle, error_message } = getQueryParams();
        setStatus(status);
        toggle && setToggle(toggle);
        setErrorMessage(error_message);
    }, [location]);

    // Check if loanSanctionDate is valid
    if (isNaN(loanSanctionDate.getTime())) {
        console.error("Invalid Loan Sanction Date");
        return null;
    }

    const formated = (dateee) => {
        const date = new Date(dateee);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    }

    const handlePaymentSubmit = async (event) => {
        event.preventDefault();
        if (request.from === undefined || request.to === undefined) {
            toast.error("Please select the valid date range")
        } else if (request.from === "" || request.to === "") {
            toast.error("Please select the valid date range")
        } else {
            const fromParts = request.from.split('/');
            const toParts = request.to.split('/');

            const formattedFrom = `${fromParts[1]}-${fromParts[0]}-${fromParts[2]}`;
            const formattedTo = `${toParts[1]}-${toParts[0]}-${toParts[2]}`;

            let start = new Date(formattedFrom);
            let end = new Date(formattedTo);
            if (end >= start) {
                await setFromDate(formated(start));
                await setToDate(formated(end));
                const formData = new FormData(event.target);
                const data = Object.fromEntries(formData.entries());
                console.log(`data inside Account statement ${JSON.stringify(data)}`)
                if (data.amount <= 0) {
                    toast.error("Amount must be greater than 0")
                } else if (data.type === "Pay and Generate") {
                    setIsPaymentButtonPressed(true);
                    axios.post(`${apiurl}/submit_payment`, data, {
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    }).then(response => {
                        window.location.href = response.data.redirecturl;
                        axios.post(`${apiurl}/record_As_data`, soaPaymentDatas, {
                            withCredentials: true,
                            headers: {
                                'Content-Type': 'application/json',
                            }
                        })
                            .then(response => {
                                console.log(response.data);
                            })
                            .catch(error => {
                                console.error(error);
                            });

                    }).catch(error => {
                        if (error.response) {
                            if (error.response.data.status == "500") {
                                toast.error("Unable to perform this operation at this time. Please try again later!");
                            }
                        }
                    });
                } else if (data.type === "Generate") {
                    setIsPaymentButtonPressed(true);
                    axios.post(`${apiurl}/directgenerate`, data, {
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    }).then(response => {
                        if (response.data.response.status == "200") {
                            toast.success("Statement of Account Generated Successfully");
                            axios.post(`${apiurl}/record_As_data`, soaPaymentDatas, {
                                withCredentials: true,
                                headers: {
                                    'Content-Type': 'application/json',
                                }
                            })
                                .then(response => {
                                    console.log(response.data);
                                    window.location.reload();
                                })
                                .catch(error => {
                                    console.error(error);
                                });
                        }
                        else {
                            toast.error("Something went wrong. Please try again later!");
                        }

                    }).catch(error => {
                        console.log('payment error:', error)
                    });
                }
            } else {
                toast.error("To Date can't be less than From Date")
            }
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setRequest((prev) => ({ ...prev, [name]: value }));
    };

    return (
        <>
            <ToastContainer />
            <div className="maincontainer">
                <h2>Account Statement</h2>
                <div className="mainsubcontainer" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
                    {loanData ? (
                        <>
                            <div>
                                <div className='amountpayable' style={{ marginBottom: '1vw' }}>
                                    <b>{`Statement of Account Charges : Rs. ${loanData.SOAPaymentAllowed != true ? " 0/-" : showAaccountStatementAmount ? showAaccountStatementAmount + " + Applicable GST" : "NA"}`}</b>
                                </div>
                                <div style={{ backgroundColor: '#d3d3d357', borderRadius: '.6vw' }} className="createaccountstatement">
                                    <DatePickerComponent Request={request} handleChange={handleChange} />
                                    <form onSubmit={handlePaymentSubmit}>
                                        <input type='hidden' name="csrfToken" value={csrfToken} />
                                        <input type="hidden" name="amount" value={paymentData} />
                                        <input type="hidden" name="udf2" value={toDate} />
                                        <input type="hidden" name="udf4" value="Account Statement Payment" />
                                        <input type="hidden" name="udf5" id="fromdateee" value={fromDate} />

                                        {loanData.SOAPaymentAllowed === true ? (
                                            <>
                                                <input type="hidden" name="type" value="Pay and Generate" />
                                                <div style={{ textAlign: 'center' }}>
                                                    <input
                                                        type="submit"
                                                        value={isPaymentButtonPressed ? "Please Wait" : "Pay and Generate"}
                                                        className='statementbutton'
                                                        style={{
                                                            background: theme.palette.maincolor.buttoncolor,
                                                            color: theme.palette.maincolor.light
                                                        }}
                                                    />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <input type="hidden" name="type" value="Generate" />
                                                <div style={{ textAlign: 'center' }}>
                                                    <input
                                                        type="submit"
                                                        value={isPaymentButtonPressed ? "Please Wait" : "Generate"}
                                                        className='statementbutton'
                                                        style={{
                                                            background: theme.palette.maincolor.buttoncolor,
                                                            color: theme.palette.maincolor.light
                                                        }}
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </form>
                                </div>
                            </div>
                            <div style={{ marginTop: '1vw', fontWeight: '800' }}>View History</div>
                            <ServiceStatus activeservicename = 'Statement of Accounts'/>
                        </>
                    ) : <div style={{ textAlign: 'center' }}>
                        <ClipLoader
                            color="rgb(155,57,19)"
                            loading={true}
                            cssOverride={overridee}
                            size={30}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </div>}
                </div>
                {toggle === '2' && status === 'failure' && <PaymentFailure error_message={errorMessage} toredirect="1" />}
            </div>
        </>
    );
}